import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./themes";
import { MapProvider } from "./contexts/MapContext";
import { LayersProvider } from "./contexts/LayersContext";
import { UIProvider } from "./contexts/UIContext";
import { SelectionProvider } from "./contexts/SelectionContext";
import useAuth from "./hooks/useAuth";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";

// Root composition (US-874 · R-2, R-5, R-6, R-9). The Atlas Standard theme is
// applied app-wide via ThemeProvider + CssBaseline. State is split by concern so
// there is no "god context": MapProvider owns the map ref + lifecycle, LayersProvider
// owns layer-visibility state (US-875), UIProvider owns UI/selection state, and
// SelectionProvider (US-878) applies the drill-down/filters to the map over that
// state. The base auth gate (skeleton — R-6/R-10) switches Login ↔ Dashboard; the
// providers wrap only the authed view. Real auth is US-882.
const App = () => {
  const { isAuthed, login } = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isAuthed ? (
        <MapProvider>
          <LayersProvider>
            <UIProvider>
              <SelectionProvider>
                <Dashboard />
              </SelectionProvider>
            </UIProvider>
          </LayersProvider>
        </MapProvider>
      ) : (
        <Login onLogin={login} />
      )}
    </ThemeProvider>
  );
};

export default App;
